/**
 * @module ToggleSwitch
 * @description Unified on/off toggle switch — inline styles (purge-safe).
 *
 * Active:   #22c55e (green), white knob right
 * Inactive: #d1d5db (gray), white knob left
 *
 * @since v2.35.0
 */
export function ToggleSwitch({ checked, onChange, disabled }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        width: '44px',
        height: '24px',
        borderRadius: '9999px',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        backgroundColor: checked ? '#22c55e' : '#d1d5db',
        transition: 'background-color 200ms',
        padding: 0,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: '18px',
          height: '18px',
          borderRadius: '9999px',
          backgroundColor: '#ffffff',
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          transition: 'transform 200ms',
          transform: checked ? 'translateX(23px)' : 'translateX(3px)',
        }}
      />
    </button>
  );
}
